// iter v29 r213 — Indicatore visuale pull-to-refresh.
//
// Si mostra in cima alla pagina quando l'utente sta tirando giù.
// Rotazione del chevron progressiva con la distanza, poi spinner durante
// il refresh. Auto-nascosto a riposo.

import React from "react";
import { ArrowsClockwise, CaretDown } from "@phosphor-icons/react";

export default function PullIndicator({ pullDistance = 0, isRefreshing = false, threshold = 70 }) {
  if (pullDistance <= 0 && !isRefreshing) return null;
  const isReady = pullDistance >= threshold;
  const rotation = Math.min(180, (pullDistance / threshold) * 180);
  const opacity = Math.min(1, pullDistance / 35);

  return (
    <div
      className="absolute left-0 right-0 top-0 flex items-center justify-center pointer-events-none z-30"
      style={{
        height: isRefreshing ? 50 : pullDistance,
        opacity: isRefreshing ? 1 : opacity,
        transition: isRefreshing ? "height 200ms ease-out" : "none",
      }}
      data-testid="pull-indicator"
    >
      <div className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white shadow-sm border border-[#E5E7E0]">
        {isRefreshing ? (
          <ArrowsClockwise size={16} weight="bold" className="text-[#7C8B6E] animate-spin" />
        ) : (
          <CaretDown
            size={16}
            weight="bold"
            className={isReady ? "text-[#7C8B6E]" : "text-[#9A968B]"}
            style={{ transform: `rotate(${rotation}deg)`, transition: "transform 100ms linear" }}
          />
        )}
      </div>
    </div>
  );
}
